import { render, staticRenderFns } from "./ReportsHelpdesk.vue?vue&type=template&id=76760b96&"
import script from "./ReportsHelpdesk.vue?vue&type=script&lang=js&"
export * from "./ReportsHelpdesk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports